import { useEffect } from 'react';

import NewFooter from '@components/shared/NewFooter';
import BrandLogos from '@components/tenants/whirlpool/BrandLogos';
import { MobileMenu, type NavItem } from '@domgen/b2bce-base-ui-design-system-lib';
import { componentLoader } from '@utils/componentLoader';
import cn from 'classnames';

const Header = componentLoader('Header');

const classes = {
  drawer: {
    root: 'fixed inset-0 z-50 transform transition-transform duration-300 ease-in-out',
    container: 'min-h-screen w-full bg-white shadow-xl overflow-auto max-h-screen'
  },
  brandLogos: 'md:hidden justify-start mt-20 p-5 gap-10 flex-wrap self-stretch',
  footer: {
    root: 'lg:px-0',
    container: 'md:w-900 mx-auto'
  }
};

type MobileDrawerProps = {
  isOpen: boolean;
  navItems: NavItem[];
  onClose?: () => void;
};

const MobileDrawer = ({ isOpen, navItems, onClose }: MobileDrawerProps) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }, [isOpen]);

  const drawerRootClasses = cn(classes.drawer.root, {
    ['translate-x-0']: isOpen,
    ['translate-x-full']: !isOpen
  });

  return (
    <div className={drawerRootClasses}>
      <div className={classes.drawer.container}>
        <Header hideBrands isMobileDrawerOpen={isOpen} toggleMobileDrawer={onClose} />
        <MobileMenu items={navItems} />
        <BrandLogos className={classes.brandLogos} />
        <NewFooter />
      </div>
    </div>
  );
};

export default MobileDrawer;
